<span
  class="folio-pill folio-pill-interactive"
  [ngClass]="pillClass"
>
  <span class="folio-pill__code">{{ folio }}</span>

  <span
    *ngIf="showHours && hours != null"
    class="folio-pill__hours"
  >· {{ hours }} h</span>

  <button
    type="button"
    class="btn-copy-folio"
    [class.is-copied]="isCopied"
    [attr.aria-label]="'Copiar folio ' + folio"
    (click)="onCopy($event)"
  >
    <span *ngIf="!isCopied" aria-hidden="true">⧉</span>
    <span *ngIf="isCopied" aria-hidden="true">✓</span>
  </button>
</span>
